import $ from 'jquery';

export default class Siloing {
  init() {
    this.launchSiloing();
    // this.launchSiloingFancybox();
  }

  launchSiloing() {
    // Ecouteur placé sur le DOM pour prise en compte des liens obfusqués au sein du contenu chargé en différé
    $(document).on('click', '[data-siloing]:not(.quick-view):not(.fancybox):not(.fancybox_iframe):not([data-fancybox]):not([data-toggle])', function (e) {
      var this_attr = $(this).attr('target');
      var this_link = $(this).data('siloing');

      if (this_attr != '' && this_attr == '_self') {
        window.location.href = this_link;
      } else if (this_attr == '_parent') {
        window.parent.location.href = this_link;
      } else if (this_attr == '_blank') {
        window.open(this_link);
      } else {
        window.location.href = this_link;
      }
    });
  }

  launchSiloingFancybox() {
    $(document).on('click', '[data-siloing][data-fancybox]').fancybox({
      href: $(this).data('siloing')
    });
  }
}
